import React from 'react'

import { IOrganization } from 'types'

interface IOrganizationContext {
  currentOrganization: IOrganization
  isLoadingOrganization: boolean
  // merge a saved organization (PATCH /organizations/{id} response) into the active route state,
  // so the page reflects a rename / currency change without a reload
  updateCurrentOrganization?: (organization: Partial<IOrganization>) => void
}

const OrganizationsContext = React.createContext<IOrganizationContext>({
  // @ts-ignore 
  currentOrganization: { id: 0, name: '', slug: '', currency_id: 'USD' },
  isLoadingOrganization: false,
})

export default OrganizationsContext
